module.exports = __webpack_public_path__ + "7f14c06a5f06d001fc17b9c2498bd2ad.png";